(() => {
  'use strict';
  if (window.__gmProductSchemaSync) return;
  window.__gmProductSchemaSync = true;
  const pending = new WeakMap();
  const version = 'gm-variant-schema-20261007';
  const formId = form => {
    const id = form?.getAttribute('id');
    return typeof id === 'string' && id.trim() ? id : null;
  };
  const ownedHead = () => {
    const nodes = document.head.querySelectorAll('script[data-gm-product-schema]');
    return nodes.length === 1 ? nodes[0] : null;
  };
  const productNode = graph => {
    if (!graph || graph['@context'] !== 'https://schema.org' || !Array.isArray(graph['@graph'])) return null;
    const nodes = graph['@graph'].filter(node => node && node['@type'] === 'Product');
    return nodes.length === 1 ? nodes[0] : null;
  };
  const mainPicker = form => {
    const id = formId(form);
    if (!id) return null;
    const pickers = Array.from(document.querySelectorAll('variant-picker[context="main_product"]'))
      .filter(picker => picker.isConnected && picker.getAttribute('form-id') === id);
    return pickers.length === 1 ? pickers[0] : null;
  };
  const connectedForm = form => form && form.tagName === 'FORM' && formId(form) &&
    form.isConnected && document.getElementById(formId(form)) === form;

  document.addEventListener('product:rerender', event => {
    try {
      const form = event.target;
      if (!connectedForm(form)) return;
      const id = formId(form);
      pending.delete(form);
      const detail = event.detail;
      if (!detail || detail.productChange || !detail.htmlFragment) return;
      const owner = mainPicker(form);
      const head = ownedHead();
      if (!owner || !head || head.getAttribute('data-gm-schema-version') !== version) return;
      const nodes = Array.from(detail.htmlFragment.querySelectorAll('script[data-gm-variant-schema]'))
        .filter(node => {
          const picker = node.closest('variant-picker');
          return picker && picker.getAttribute('context') === 'main_product' &&
            picker.getAttribute('form-id') === id &&
            picker.getAttribute('section-id') === owner.getAttribute('section-id') &&
            node.getAttribute('data-gm-form-id') === id &&
            node.getAttribute('data-gm-section-id') === owner.getAttribute('section-id');
        });
      if (nodes.length !== 1) return;
      const payload = nodes[0];
      if (payload.type !== 'application/json' ||
          payload.getAttribute('data-gm-schema-version') !== version ||
          payload.getAttribute('data-gm-product-id') !== head.getAttribute('data-gm-product-id') ||
          payload.getAttribute('data-gm-currency') !== head.getAttribute('data-gm-currency')) return;
      const incoming = productNode(JSON.parse(payload.textContent));
      const current = productNode(JSON.parse(head.textContent));
      if (!incoming || !current || incoming['@id'] !== current['@id'] || incoming.url !== current.url) return;
      const quoteMode = head.getAttribute('data-gm-quote-only');
      if (!['true', 'false'].includes(quoteMode) || payload.getAttribute('data-gm-quote-only') !== quoteMode) return;
      const quoteOnly = quoteMode === 'true';
      const offer = incoming.offers;
      const variantId = payload.getAttribute('data-gm-variant-id');
      const currency = head.getAttribute('data-gm-currency');
      if (!/^\d+$/.test(variantId || '') || !/^[A-Z]{3}$/.test(currency || '')) return;
      let ogPrice = null, availability = payload.getAttribute('data-gm-availability');
      if (quoteOnly) {
        if (Object.prototype.hasOwnProperty.call(incoming, 'offers') || payload.hasAttribute('data-gm-og-price') || !['in stock', 'out of stock'].includes(availability)) return;
      } else {
      if (
          !offer || offer['@type'] !== 'Offer' || offer.priceCurrency !== currency ||
          typeof offer.price !== 'number' || !Number.isFinite(offer.price) || offer.price < 0 ||
          !['https://schema.org/InStock', 'https://schema.org/OutOfStock'].includes(offer.availability)) return;
      const offerUrl = new URL(offer.url, document.location.href);
      const productUrl = new URL(current.url, document.location.href);
      if (offerUrl.origin !== productUrl.origin || offerUrl.pathname !== productUrl.pathname ||
          offerUrl.searchParams.get('variant') !== variantId) return;
      ogPrice = payload.getAttribute('data-gm-og-price');
      if (!ogPrice) return;
      availability = incoming.offers.availability.endsWith('/InStock') ? 'in stock' : 'out of stock';
      }
      pending.set(form, {head, incoming, variantId, currency, ogPrice, quoteOnly, quoteMode, availability,
        sectionId: owner.getAttribute('section-id')});
    } catch (_) {
      pending.delete(event.target);
    }
  }, true);

  document.addEventListener('variant:change', event => {
    try {
      const form = event.target;
      const update = pending.get(form);
      pending.delete(form);
      if (!update || !connectedForm(form) || !event.detail || !event.detail.variant) return;
      const picker = mainPicker(form);
      const id = form.querySelector('[name="id"]');
      if (!picker || picker.getAttribute('section-id') !== update.sectionId || !id ||
          String(event.detail.variant.id) !== update.variantId || String(id.value) !== update.variantId ||
          ownedHead() !== update.head || update.head.getAttribute('data-gm-currency') !== update.currency || update.head.getAttribute('data-gm-quote-only') !== update.quoteMode) return;
      const graph = JSON.parse(update.head.textContent);
      const current = productNode(graph);
      if (!current || current['@id'] !== update.incoming['@id']) return;
      graph['@graph'][graph['@graph'].indexOf(current)] = update.incoming;
      update.head.textContent = JSON.stringify(graph).replace(/</g, '\\u003c');
      update.head.setAttribute('data-gm-variant-id', update.variantId);
      if (update.quoteOnly) document.head.querySelectorAll('meta[data-gm-product-meta][property="product:price:amount"],meta[data-gm-product-meta][property="product:price:currency"]').forEach(node => node.remove());
      for (const [property, content] of [
        ['product:price:amount', update.ogPrice],
        ['product:price:currency', update.currency],
        ['product:availability', update.availability]
      ]) {
        const meta = document.head.querySelectorAll(`meta[data-gm-product-meta][property="${property}"]`);
        if (content !== null && meta.length === 1) meta[0].setAttribute('content', content);
      }
    } catch (_) {
      pending.delete(event.target);
    }
  });
})();
